import { Box, styled } from '@mui/material';

export const LandingPageContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'barHeight',
})(({ barHeight }) => ({
  height: barHeight && `calc(100% - ${barHeight}px)`,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  marginTop: barHeight && `${barHeight}px`,
}));
